import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';

import {
  getApplicantJobsSuccessAction,
  setApplicantJobsIsLoadingAction,
  createApplicantJobSuccessAction,
  updateApplicantJobSuccessAction,
  setApplicantJobsCountAction,
  getApplicantJobsPendingSuccessAction,
  deleteJobSuccessAction,
  getSingleApplicantJobSuccessAction,
  updateApplicantApplicantStatusSuccessAction,
  getApplicantJobsRecmSuccessAction
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction
} from '../notifications/Actions';
import * as api from './Api';
import { push } from 'connected-react-router';

function* createApplicantJob({ payload }) {
  if (payload.skills) payload.skills = payload.skills.split(',');

  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.createApplicantJob, payload);
    const { data } = response;
    const job = data;
    yield put(createApplicantJobSuccessAction(job));
    yield put(newSuccessNotificationAction(`Job Created : ${job.title}`));

    yield put(push('/jobs/applicant/pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

function* updateAtrisanJob({ payload: { id, formData } }) {
  if (formData.skills) formData.skills = formData.skills.split(',');
  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.updateApplicantJob, id, formData);
    const { data } = response;
    const updatedJob = data;
    yield put(updateApplicantJobSuccessAction(updatedJob));
    yield put(newSuccessNotificationAction(`Updated Job : ${updatedJob.name}`));
    yield put(push('/applicant-jobs/pending'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

function* getApplicantJobs({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '1'
      }
    ],
    filterApplicant: payload?.applicantId,
    filterApplicantCategory: '',

    sort: 'createdAt',
    dir: 'desc',
    applicantId: payload?.applicantId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.getApplicantJobs, body);
    const { data } = response;

    const count = data.count;
    const applicantJobs = data.content;

    yield put(setApplicantJobsCountAction(count));
    yield put(getApplicantJobsSuccessAction(applicantJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}
function* getApplicantJobsRecm({ payload }) {
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '1'
      }
    ],
    filterApplicant: payload?.applicantId,
    filterApplicantCategory: '',

    sort: 'createdAt',
    dir: 'desc',
    applicantId: payload?.applicantId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.getApplicantJobsRecm, body);
    const { data } = response;

    const count = data.count;
    const applicantJobs = data.content;

    yield put(getApplicantJobsRecmSuccessAction(applicantJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}
function* getSingleJob({ payload }) {
  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.getSingleApplicantJob, payload);
    const { data } = response;

    const applicantJob = data;

    yield put(getSingleApplicantJobSuccessAction(applicantJob));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

function* getApplicantPendingJobs({ payload }) {
  console.log(payload, 'payloadpayload');
  const defData = {
    offset: 0,
    size: 10,
    searchTerm: '',
    filterBy: [
      {
        jobType: '1'
      }
    ],
    filterApplicant: payload?.applicantId,
    filterApplicantCategory: '',
    sort: 'createdAt',
    dir: 'desc',
    profileId: payload?.applicantId
  };

  const body = { ...defData, ...payload };

  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.getApplicantPendingJobs, body);
    const { data } = response;

    const count = data.count;
    const applicantJobs = data.content;

    yield put(setApplicantJobsCountAction(count));
    yield put(getApplicantJobsPendingSuccessAction(applicantJobs));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

function* updateApplicantStatus({ payload }) {
  if (payload.skills) payload.skills = payload.skills.split(',');
  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    const response = yield call(api.putUpdateApplicantStatus, payload);
    const { data } = response;

    yield put(updateApplicantApplicantStatusSuccessAction(data));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

function* deleteJob({ payload }) {
  try {
    yield put(setApplicantJobsIsLoadingAction(true));
    yield call(api.deleteApplicantJob, payload);

    yield put(deleteJobSuccessAction(payload));
    yield put(newSuccessNotificationAction('Job Deleted'));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setApplicantJobsIsLoadingAction(false));
  }
}

export default function*() {
  yield takeLatest(actions.GET_JAPPLICANT, getApplicantJobs);
  yield takeLatest(actions.GET_JAPPLICANT_RECOM, getApplicantJobsRecm);
  yield takeLatest(actions.GET_JAPPLICANT_PENDING, getApplicantPendingJobs);
  yield takeLatest(actions.CREATE_JAPPLICANT, createApplicantJob);
  yield takeLatest(actions.UPDATE_JAPPLICANT, updateAtrisanJob);
  yield takeLatest(actions.DELETE_JAPPLICANT, deleteJob);
  yield takeLatest(actions.GET_SINGLE_JAPPLICANT, getSingleJob);
  yield takeLatest(
    actions.UPDATE_JAPPLICANT_APPLICANT_STATUS,
    updateApplicantStatus
  );
}
